import CodeIcon from './CodeIcon';

export {
  CodeIcon
};